import { v4 as uuid } from 'uuid';

export const KEY = '@readme-session-key';

/**
 * Returns a unique identifier for the current browser session.
 * The identifier is stored in sessionStorage and persists across page reloads
 * but is cleared when the tab or browser is closed.
 *
 * @example
 * const sessionId = getSessionKey();
 * console.log(sessionId); // e.g. "1697051234567"
 */
export default function getSessionKey() {
  if (typeof window === 'undefined') {
    return null;
  }
  if (!sessionStorage.getItem(KEY)) {
    // Fallback to timestamp if running in non-secure context (e.g. http not https)
    const hash = crypto?.randomUUID?.() || uuid();
    sessionStorage.setItem(KEY, hash);
  }

  return sessionStorage.getItem(KEY);
}
